export default {
	common: {
		noMore: '没有更多了',
		noEmpty: '必传',
		copySuccess: '复制成功',
		copyFail: '复制失败',
		paySuccess: '支付成功',
		payFail: '支付失败',
		search: '搜索',
		remark: '备注',
		commit: '提交',
		status: '状态',
		revoke: '撤销',
		cancel: '取消',
		confirm: '确认',
		close: '关闭',
		getbtn: '领取',
		selectTime: '选择时间',
		selectDate: '选择日期',
		uploadImage: '图片上传',
		uploadVideo: '视频上传',
		activity: '活动',
		problem: '问题',
		money: '金额',
		reply: '回复',
		other: '其他',
		send: '发送',
		copy: '复制',
		view: '查看',
		next: '下一步',
		feedback: '我要反馈',
		enter: '请输入',
		loading: '加载中...',
		rotateTips: '为了更好体验，请旋转手机',
		purchase: '购买',
		purchased: '已购买',
		getBtn: '领取',
		onekeyGetBtn: '一键领取',
		freeGetBtn: '免费领取',
		countdown: '倒计时',
		days: '天',
		hour: '小时',
		minute: '分',
		second: '秒',
		ruleDefault: '无',
		emptyDefault: '哎呀，这里什么都没有～',
		monetaryUnit: '元',
		mUnit: '￥',
		ruleTitle: '规则说明',
		tipsTitle: '提示',
		repeatTips: '请勿频繁操作～',
		thousand: '千',
		tenThousand: '万',
		tenMillion: '千万',
		billion: '亿',
		hundredBillion: '千亿',
		trillions: '万亿',
		quadrillions: '千万亿',
		noOpen: '暂未开放'
	},
	menu: {
		home: '首頁',
		about: '關於我們',
		contact: '聯繫我們',
		clauseService: '隱私政策',
		clauseUser: '使用者協定'
	},
	footer: {
		company: 'HK BUFF TECHNOLOGY',//'HONG KONG BUFF TECHNOLOGY CO., LIMITED',
		email: "gaofenfang0221{'@'}gmail.com",
		tel: '+85292272906',
		addr: ''//'RM 517 NEW CITY CTR 2 LEI YUEMUN RD KWUN TONGHONG KONG'
	},
	upload: {
		label: '上传',
		loading: '上传中...',
		success: '上传成功',
		fail: '上传失败',
		sizeTips: '文件大小不能超过 {size} M',
	}
}